// extracted by mini-css-extract-plugin
export default {"addressSection":"pW-z","disabled":"qW-z","sectionButtons":"rW-z","logo":"sW-z"};